export function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export enum States{
    Done = "Done",
    Loading = "Loading",
    NotStarted = "Not Started"
}